"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "pergine-valsugana": {
    "0485a658": [{
      "hkey": "7d3b0009",
      "slug": "pergine-valsugana",
      "name": "Pergine Valsugana",
      "primary": true,
      "skipSearch": false
    }],
    "castagne": [{
      "hkey": "7d3b0009",
      "slug": "pergine-valsugana",
      "name": "Pergine Valsugana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1b3efdf8": [{
      "hkey": "f223b3b7",
      "slug": "cire-fratte",
      "name": "Cirè-Fratte",
      "primary": true,
      "skipSearch": false
    }],
    "cire": [{
      "hkey": "f223b3b7",
      "slug": "cire-fratte",
      "name": "Cirè-Fratte",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "a64e704a": [{
      "hkey": "c9f1da91",
      "slug": "madrano-canzolino",
      "name": "Madrano-Canzolino",
      "primary": true,
      "skipSearch": false
    }],
    "madrano": [{
      "hkey": "c9f1da91",
      "slug": "madrano-canzolino",
      "name": "Madrano-Canzolino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "77510bed": [{
      "hkey": "bfea6e58",
      "slug": "casalino-vigalzano",
      "name": "Casalino-Vigalzano",
      "primary": true,
      "skipSearch": false
    }],
    "vigalzano": [{
      "hkey": "bfea6e58",
      "slug": "casalino-vigalzano",
      "name": "Casalino-Vigalzano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;